import { authRoles } from 'src/app/auth';
import ArchivePage from './ArchivePage/ArchivePage';
import CreateDocumentPage from './CreateDocumentPage/CreateDocumentPage';
import IncomingDocumentsPage from './IncomingDocumentsPage/IncomingDocumentsPage';
import OutgoingDocumentsPage from './OutgoingDocumentsPage/OutgoingDocumentsPage';

const DocumentsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: '/apps/documents-2/create-document',
      element: <CreateDocumentPage />,
    },
    {
      path: '/apps/documents-2/incoming-document',
      element: <IncomingDocumentsPage />,
    },
    {
      path: '/apps/documents-2/outgoing-document',
      element: <OutgoingDocumentsPage />,
    },
    {
      path: '/apps/documents-2/archive',
      element: <ArchivePage />,
    },
  ],
};

export default DocumentsConfig;
